import { PiBuildingsDuotone } from "react-icons/pi";
import { assetUrl } from "@/context/BrandingContext";
import AssetImage from "../../components/AssetImage";

export default function MasterBrand({ brand }) {
  return (
    <div className="h-16 flex items-center gap-2 px-3 lg:px-5 border-b border-slate-800 shrink-0">
      <div className="w-9 h-9 bg-cyan-400 flex items-center justify-center shrink-0"
        style={brand.platform_logo_url ? { background: "transparent" } : { background: brand.primary_color }}>
        {brand.platform_logo_url
          ? <AssetImage src={assetUrl(brand.platform_logo_url)} alt="logo" className="w-9 h-9 object-contain" data-testid="master-brand-logo" />
          : <PiBuildingsDuotone className="text-[#080D18] text-xl" />}
      </div>
      <div className="hidden lg:block leading-none">
        <div className="font-chivo font-black text-sm tracking-tight text-slate-50 truncate" data-testid="master-brand-name">
          {brand.platform_name}
        </div>
        <div className="font-mono text-[9px] tracking-[0.2em] uppercase mt-1" style={{ color: brand.primary_color }}
          data-testid="master-brand-tagline">
          {brand.platform_tagline}
        </div>
      </div>
    </div>
  );
}
